import SettingsPage from './components/SettingsPage';

const routes = [
  {
    path: '/settings',
    name: 'menu.settings',
    icon: 'settings',
    customIcon: true,
    loginRequired: true,
    component: SettingsPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
